<template>
  <div v-if="(block.isShowed('text_share') && text) || (block.isShowed('sharing_methods') && sharingMethods.length)">
    <h3
      class="title color--lg"
      v-if="block.isShowed('text_share') && text"
    >
      {{ text }}
    </h3>

    <app-share
      :networks="sharingMethods"
      whatsapp-text="project_page.share_whatsapp_text_url"
      email-text="project_page.share_email_text_url"
      x-text="project_page.share_twitter_text_url"
      :target-id="project.id"
      target-type="Project"
      :disabled="isDisabled"
      v-if="sharingMethods.length"
    />
  </div>
</template>

<script setup>
import { computed, defineAsyncComponent, inject } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { get as _get } from 'lodash'

const AppShare = defineAsyncComponent(() => import('&/molecules/AppShare'))

const { block } = defineProps({
  column: { type: Object, required: true },
  block: { type: Object, required: true }
})

const { translate } = useI18n()

const objects = inject('objects', {})

const project = computed(() => _get(objects.value, 'project'))
const text = computed(() => translate(block.getText('share')))
const sharingMethods = computed(() => _get(block.attributes, 'sharing_methods', []))
const isDisabled = computed(() => project.value?.status !== 'published')
</script>

<style lang="scss" scoped>
.title {
  font-size: rem(14px);
}
</style>